import React from 'react';

const EidBackgroundGraphics = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden select-none">
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 80% 20%, rgba(16, 185, 129, 0.20) 0%, rgba(245, 158, 11, 0.15) 35%, transparent 65%), radial-gradient(circle at 20% 80%, rgba(6, 182, 212, 0.12) 0%, transparent 60%)'
        }}
      />

      <svg viewBox="0 0 1600 1000" className="w-full h-full object-cover" preserveAspectRatio="xMidYMid slice">
        <defs>
          <linearGradient id="crescentGlow" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FEF08A" />
            <stop offset="60%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#D97706" />
          </linearGradient>
          <filter id="eidHalo" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
          </filter>
        </defs>

        {/* Luminous Ornate Crescent Moon & Star */}
        <g transform="translate(1280, 180)">
          <circle cx="0" cy="0" r="58" fill="url(#crescentGlow)" filter="url(#eidHalo)" opacity="0.4" />
          <circle cx="0" cy="0" r="54" fill="url(#crescentGlow)" />
          <circle cx="-16" cy="-12" r="48" fill="#061811" />
          {/* Star */}
          <polygon points="12,-4 18,-18 32,-18 20,-28 24,-42 12,-32 0,-42 4,-28 -8,-18 6,-18" fill="#FEF08A" transform="scale(0.8) translate(15, 10)" />
        </g>

        {/* Hanging Filigree Fanoos Lanterns */}
        <g stroke="#F59E0B" strokeWidth="1.5" fill="none">
          <line x1="220" y1="0" x2="220" y2="160" />
          <polygon points="210,160 230,160 226,195 214,195" fill="#F59E0B" fillOpacity="0.3" stroke="#F59E0B" />
          <circle cx="220" cy="177" r="5" fill="#FEF08A" />

          <line x1="420" y1="0" x2="420" y2="240" />
          <polygon points="408,240 432,240 427,285 413,285" fill="#F59E0B" fillOpacity="0.3" stroke="#F59E0B" />
          <circle cx="420" cy="262" r="6" fill="#FEF08A" />
        </g>

        {/* Majestic Mosque Dome & Minaret Silhouettes */}
        <g fill="#0C2A1E">
          <rect x="0" y="660" width="380" height="340" />
          {/* Minaret */}
          <rect x="280" y="440" width="30" height="220" />
          <polygon points="280,440 295,390 310,440" />
          <circle cx="295" cy="385" r="4" fill="#F59E0B" />

          {/* Right Mosque Complex */}
          <rect x="1220" y="660" width="380" height="340" />
          <rect x="1280" y="440" width="30" height="220" />
          <polygon points="1280,440 1295,390 1310,440" />
          <circle cx="1295" cy="385" r="4" fill="#F59E0B" />
        </g>

        {/* Rolling Sand Dunes */}
        <path d="M0 760 Q400 680 800 750 T1600 730 L1600 1000 L0 1000 Z" fill="#092017" />
        <path d="M0 840 Q600 760 1200 850 T1600 820 L1600 1000 L0 1000 Z" fill="#04120D" />
      </svg>
    </div>
  );
};

export default EidBackgroundGraphics;
